import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { protectFeature } from '~libs.shared.system';
import { isFunction } from '~libs.typescript';

import { VisitPatientWithExternalIdentifier } from './types';
import { checkVisitPatientWithExternalIdentifier } from './checkVisitPatientWithExternalIdentifier';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
type FeatureIds = Parameters<typeof protectFeature>[0];

type ResourceRenderer<RESOURCE> = (visitPatientWithExternalIdentifier: VisitPatientWithExternalIdentifier) => RESOURCE;

export const createPatientWithExternalIdentifierProtector = (patient: VisitPatient) => {
   return <RESOURCE, FALLBACK_RESOURCE>(
      featureIds: FeatureIds,
      resource: ResourceRenderer<RESOURCE> | RESOURCE,
      fallbackResource?: FALLBACK_RESOURCE
   ): RESOURCE | FALLBACK_RESOURCE | null => {
      const externalIdentifier = checkVisitPatientWithExternalIdentifier(patient);
      if (!externalIdentifier) {
         return fallbackResource ?? null;
      }

      return protectFeature(featureIds, isFunction(resource) ? resource(patient) : resource, fallbackResource ?? null);
   };
};
